import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Hook to handle Electron menu navigation commands
 * This allows the Electron menu items to navigate within the React app
 */
export const useElectronNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if running in Electron
    if (window.electronAPI?.onNavigate) {
      window.electronAPI.onNavigate((path) => {
        console.log('Electron navigation to:', path);
        navigate(path);
      });
    }
  }, [navigate]);
};

/**
 * Check if the app is running in Electron
 */
export const isElectron = () => {
  return window.electronAPI?.isElectron === true;
};

/**
 * Get the app version from Electron
 */
export const getAppVersion = async () => {
  if (window.electronAPI?.getAppVersion) {
    return await window.electronAPI.getAppVersion();
  }
  return null;
};

/**
 * Show a native desktop notification
 */
export const showNotification = async (title, body) => {
  if (window.electronAPI?.showNotification) {
    return await window.electronAPI.showNotification(title, body);
  }
  // Fallback to web notifications
  if ('Notification' in window && Notification.permission === 'granted') {
    new Notification(title, { body });
    return true;
  }
  return false;
};

/**
 * Get the current platform
 */
export const getPlatform = () => {
  return window.electronAPI?.platform || 'web';
};
